import { defineComponent as x, ref as v, inject as A, computed as g, watchEffect as j, watch as O, onBeforeUnmount as P, provide as b, withDirectives as S, h as l, Transition as W, mergeProps as _, vShow as T } from "vue";
import { popoverBodyInjectionKey as I } from "./ghl-ui.es1361.js";
import { modalBodyInjectionKey as q } from "./ghl-ui.es1076.js";
import { drawerInjectionKey as K, drawerBodyInjectionKey as U } from "./ghl-ui.es1012.js";
import X from "./ghl-ui.es878.js";
import { useRtl as Y } from "./ghl-ui.es875.js";
import V from "./ghl-ui.es732.js";
import { FocusTrap as G } from "./ghl-ui.es1252.js";
import J from "./ghl-ui.es1017.js";
import { useLockHtmlScroll as Q } from "./ghl-ui.es1362.js";
const de = x({
  name: "NDrawerContent",
  inheritAttrs: !1,
  props: {
    blockScroll: Boolean,
    show: {
      type: Boolean,
      default: void 0
    },
    displayDirective: {
      type: String,
      required: !0
    },
    placement: {
      type: String,
      required: !0
    },
    contentClass: String,
    contentStyle: [Object, String],
    nativeScrollbar: {
      type: Boolean,
      required: !0
    },
    scrollbarProps: Object,
    trapFocus: {
      type: Boolean,
      default: !0
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    showMask: {
      type: [Boolean, String],
      required: !0
    },
    maxWidth: Number,
    maxHeight: Number,
    minWidth: Number,
    minHeight: Number,
    resizable: Boolean,
    onClickoutside: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    onEsc: Function
  },
  setup(t) {
    const r = v(!!t.show), m = v(null), h = A(K);
    let a = 0, w = "", s = null;
    const f = v(!1), d = v(!1), y = g(() => t.placement === "top" || t.placement === "bottom"), {
      mergedClsPrefixRef: M,
      mergedRtlRef: B
    } = X(t), E = Y("Drawer", B, M), D = (e) => {
      d.value = !0, a = y.value ? e.clientY : e.clientX, w = document.body.style.cursor, document.body.style.cursor = y.value ? "ns-resize" : "ew-resize", document.body.addEventListener("mousemove", p), document.body.addEventListener("mouseleave", R), document.body.addEventListener("mouseup", u);
    }, C = () => {
      s !== null && (window.clearTimeout(s), s = null), d.value ? f.value = !0 : s = window.setTimeout(() => {
        f.value = !0;
      }, 300);
    }, z = () => {
      s !== null && (window.clearTimeout(s), s = null), f.value = !1;
    }, {
      doUpdateHeight: L,
      doUpdateWidth: $
    } = h, H = (e) => {
      const {
        maxWidth: o
      } = t;
      if (o && e > o)
        return o;
      const {
        minWidth: i
      } = t;
      return i && e < i ? i : e;
    }, F = (e) => {
      const {
        maxHeight: o
      } = t;
      if (o && e > o)
        return o;
      const {
        minHeight: i
      } = t;
      return i && e < i ? i : e;
    }, p = (e) => {
      var o, i;
      if (d.value)
        if (y.value) {
          let n = ((o = m.value) === null || o === void 0 ? void 0 : o.offsetHeight) || 0;
          const c = a - e.clientY;
          n += t.placement === "bottom" ? c : -c, n = F(n), L(n), a = e.clientY;
        } else {
          let n = ((i = m.value) === null || i === void 0 ? void 0 : i.offsetWidth) || 0;
          const c = a - e.clientX;
          n += t.placement === "right" ? c : -c, n = H(n), $(n), a = e.clientX;
        }
    }, u = () => {
      d.value && (a = 0, d.value = !1, document.body.style.cursor = w, document.body.removeEventListener("mousemove", p), document.body.removeEventListener("mouseup", u), document.body.removeEventListener("mouseleave", R));
    }, R = u;
    j(() => {
      t.show && (r.value = !0);
    }), O(() => t.show, (e) => {
      e || u();
    }), P(() => {
      u();
    });
    const N = g(() => {
      const {
        show: e
      } = t, o = [[T, e]];
      return t.showMask || o.push([V, t.onClickoutside, void 0, {
        capture: !0
      }]), o;
    });
    function k() {
      var e;
      r.value = !1, (e = t.onAfterLeave) === null || e === void 0 || e.call(t);
    }
    return Q(g(() => t.blockScroll && r.value)), b(U, m), b(I, null), b(q, null), {
      bodyRef: m,
      rtlEnabled: E,
      mergedClsPrefix: h.mergedClsPrefixRef,
      isMounted: h.isMountedRef,
      mergedTheme: h.mergedThemeRef,
      displayed: r,
      transitionName: g(() => ({
        right: "slide-in-from-right-transition",
        left: "slide-in-from-left-transition",
        top: "slide-in-from-top-transition",
        bottom: "slide-in-from-bottom-transition"
      })[t.placement]),
      handleAfterLeave: k,
      bodyDirectives: N,
      handleMousedownResizeTrigger: D,
      handleMouseenterResizeTrigger: C,
      handleMouseleaveResizeTrigger: z,
      isDragging: d,
      isHoverOnResizeTrigger: f
    };
  },
  render() {
    const {
      $slots: t,
      mergedClsPrefix: r
    } = this;
    return this.displayDirective === "show" || this.displayed || this.show ? S(
      /* Keep the wrapper dom. Make sure the drawer has a host.
      Nor the detached content will disappear without transition */
      l("div", {
        role: "none"
      }, l(G, {
        disabled: !this.showMask || !this.trapFocus,
        active: this.show,
        autoFocus: this.autoFocus,
        onEsc: this.onEsc
      }, {
        default: () => l(W, {
          name: this.transitionName,
          appear: this.isMounted,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.handleAfterLeave
        }, {
          default: () => S(l("div", _(this.$attrs, {
            role: "dialog",
            ref: "bodyRef",
            "aria-modal": "true",
            class: [
              `${r}-drawer`,
              this.rtlEnabled && `${r}-drawer--rtl`,
              `${r}-drawer--${this.placement}-placement`,
              /**
               * When the mouse is pressed to resize the drawer,
               * disable text selection
               */
              this.isDragging && `${r}-drawer--unselectable`,
              this.nativeScrollbar && `${r}-drawer--native-scrollbar`
            ]
          }), [this.resizable ? l("div", {
            class: [`${r}-drawer__resize-trigger`, (this.isDragging || this.isHoverOnResizeTrigger) && `${r}-drawer__resize-trigger--hover`],
            onMouseenter: this.handleMouseenterResizeTrigger,
            onMouseleave: this.handleMouseleaveResizeTrigger,
            onMousedown: this.handleMousedownResizeTrigger
          }) : null, this.nativeScrollbar ? l("div", {
            class: [`${r}-drawer-content-wrapper`, this.contentClass],
            style: this.contentStyle,
            role: "none"
          }, t) : l(J, Object.assign({}, this.scrollbarProps, {
            contentStyle: this.contentStyle,
            contentClass: [`${r}-drawer-content-wrapper`, this.contentClass],
            theme: this.mergedTheme.peers.Scrollbar,
            themeOverrides: this.mergedTheme.peerOverrides.Scrollbar
          }), t)]), this.bodyDirectives)
        })
      })),
      [[T, this.displayDirective === "if" || this.displayed || this.show]]
    ) : null;
  }
});
export {
  de as default
};
